import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import PdfViewer from '../../../components/PdfViewer';
import Grid from '../../../components/Grid';
import { getMedia } from '../../../store/actions/media';
import { Page } from "../components/styles";
import { getOneSession } from '../../../store/actions/session';
import { getPost } from '../../../store/actions/post';
import Loader from "../../../components/LogoLoader";
import { isSubscribed } from '../../../helpers/isSubscribed';
import { useLayout } from '../../../providers/LayoutProvider';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { getFreeSubscriptions } from '../../../helpers/getFreeSubscriptions';
import MPBlockedSection from '../components/MPBlockedSection';
import NoSubscribed from '../components/NoSubscribed';
import NoUnlocked from '../../Dashboard/Posts/components/NoUnlocked';
import MPVerifyYourPaymentInformationSection from '../components/MPVerifyYourPaymentInformationSection';
import MPOldSubscribersDisapprovedPaymentSection from '../components/MPOldSubscribersDisapprovedPaymentSection';
import { getGroupById } from '../../../store/actions/group';


interface MediaViewerProps {
  user: any;
  userStates: any;
  session: any;
  sessionStates: any;
  post: any;
  postStates: any;
  media: any;
  mediaStates: any;
  isLoggedIn: boolean;
  userSubscriptions,
  subscriptionStates,
  group,
  groupStates
}

interface RouteParams {
  groupId: string;
  sessionId?: string;
  postId?: string;
  mediaId: string;
}

const MediaViewer: React.FC<MediaViewerProps> = ({
  user,
  userStates,
  session,
  sessionStates,
  post,
  postStates,
  media,
  mediaStates,
  isLoggedIn,
  userSubscriptions,
  subscriptionStates,
  group,
  groupStates
}) => {
  const { groupId, sessionId, postId, mediaId } = useParams<RouteParams>();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const { layout, setLayout } = useLayout();
  const history = useHistory();
  const theme = useTheme() as { colors: { [key: string]: string } };

  const [canDownload, setCanDownload] = useState(false);
  const [showSubscriptionModal, setShopSubscriptionModal] = useState(false);
  const [isCommunityPost, setIsCommunityPost] = useState(false);
  const [isFreePost, setIsFreePost] = useState(false);
  const [isOwner, setIsOwner] = useState(false);


  const isUserSubscribed = useMemo(() => {
    console.log('isUserSubscribed', { isLoggedIn, isOwner, group })
    if (isLoggedIn) {
      return isSubscribed(userSubscriptions, group?.id) || isOwner
    } else if (!isLoggedIn || group?.group_type === 'free_experience') {
      return isSubscribed(getFreeSubscriptions(), group?.id)
    } else {
      return false
    }
  }, [userSubscriptions, isLoggedIn, isOwner, group])

  const isMpInactiveSubscription = useMemo(() => {
    const groupSubscription = userSubscriptions?.find(subscription => subscription?.group?.id === group?.id)
    const mpInactiveSubscriptionStates = ['retrying', 'not_paid']
    return mpInactiveSubscriptionStates.includes(groupSubscription?.status)
  }, [userSubscriptions, post, group])

  const headerTitle = useMemo(() => {
    const fileName = media?.name || media?.original_name || 'Archivo';

    if (sessionId && session) {
      return `${session.title} - ${fileName}`;
    }

    if (postId && post) {
      return `${post.title} - ${fileName}`;
    }

    return fileName;
  }, [post, session, media, sessionId, postId])

  useEffect(() => {
    const contentExpertId = post?.group?.expert?.id || session?.group?.expert?.id;
    const isContentOwner = (!!post || !!session) && !!user && (contentExpertId === user?.expert?.id && contentExpertId === group?.expert?.id);
    const isCommunityPost = group?.group_type === "community";
    const isFreePost = post?.is_free;

    console.log('isContentOwner', { isContentOwner, contentExpertId, user, group, session, post })

    setIsFreePost(isFreePost);
    setIsCommunityPost(isCommunityPost);
    setIsOwner(isContentOwner);
  }, [post, user, group, session]);

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: headerTitle,
        showBack: false
      },
      header: {
        visible: true,
        beforeHeader: <><MPVerifyYourPaymentInformationSection /> <MPOldSubscribersDisapprovedPaymentSection /></>
      }
    });
  }, [headerTitle]);

  useEffect(() => {
    //TODO consultar con jona que onda esto, le agregue el !postInformation para evitar requests de mas
    if (
      !!groupId &&
      !groupStates.loading &&
      (!group?.id || (!!group?.id && group?.id !== parseInt(groupId)))
    ) {
      dispatch(getGroupById({ group_id: groupId }));
    }
  }, [groupId, groupStates]);

  useEffect(() => {
    // Cargar datos del session/post según corresponda
    if (sessionId) {
      dispatch(getOneSession({ idSession: parseInt(sessionId) }));
    } else if (postId) {
      dispatch(getPost({ idPost: parseInt(postId) }));
    }
  }, [user, sessionId, postId, dispatch, history]);

  //Verificar permisos de descarga para el post
  useEffect(() => {
    if (postId && post && parseInt(postId) === post.id) {
      const isDownloadable = post.block_files_download || false;
      setCanDownload(isDownloadable);
    }
  }, [post, postId]);

  // Verificar permisos de descarga para sessions
  useEffect(() => {
    if (sessionId && session && parseInt(sessionId) === session.id) {
      const isDownloadable = session.complementary_material_downloadable || false;
      setCanDownload(isDownloadable);
    }
  }, [session, sessionId]);

  // Obtener media file
  useEffect(() => {
    if (!!mediaId) {
      dispatch(getMedia(parseInt(mediaId)));
    };
  }, [mediaId]);

  if (postStates.error) {
    return <Redirect to="/404" />;
  }

  if (postStates.loading || groupStates.loading || sessionStates.loading || mediaStates.loading || userStates.loading || subscriptionStates.loading) {
    return (
      <Page
        style={{
          ...(isFreePost &&
            !isCommunityPost && { paddingBottom: isMobile ? "0px" : "252px" }),
        }}
      >
        <Grid.Container style={{ position: 'relative', zIndex: 1 }}>
          <Grid.Row>
            <Grid.Col lg={8} offset={{ lg: 2 }}>
              <Loader />
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      </Page>
    )
  }

  console.log({ isUserSubscribed, isOwner, isMpInactiveSubscription })

  return (
    <Page
      style={{
        ...(isFreePost &&
          !isCommunityPost && { paddingBottom: isMobile ? "0px" : "252px" }),
      }}
    >
      <Grid.Container style={{ position: 'relative', zIndex: 1 }}>
        <Grid.Row>
          <Grid.Col lg={8} offset={{ lg: 2 }}>
            <PdfViewer
              fileUrl={media?.signed_url || media?.url}
              fileName={media?.name || media?.original_name || 'Archivo'}
              blockDownloadFiles={!canDownload}
              isOwner={user?.id === media?.user?.id}
            />

            {isUserSubscribed && !isOwner && !!isMpInactiveSubscription && (
              <MPBlockedSection />
            )}

            {!isUserSubscribed && !isOwner && !isMpInactiveSubscription && (
              <NoSubscribed />
            )}

            {isUserSubscribed && !isOwner && !!post?.user_access_data && !post?.user_access_data?.is_unlocked && !isMpInactiveSubscription && (
              <NoUnlocked />
            )}
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </Page>
  );
};

const state = ({ userStore, sessionStore, postStore, mediaStore, communityStore, groupStore }: any) => {
  const { data: media, states: mediaStates } = mediaStore;
  const { data: user, states: userStates } = userStore.information;
  const { data: session, states: sessionStates } = sessionStore.one;
  const { data: post, states: postStates } = postStore.post;
  const { isLoggedIn } = userStore.isLoggedIn;
  const { data: userSubscriptions, states: userSubscriptionsStates } = userStore.subscriptions;
  const { states: subscriptionStates } = communityStore.subscription;
  const { data: group, states: groupStates } = groupStore.group;

  return {
    isLoggedIn,
    userSubscriptions,
    user,
    userStates,
    session,
    sessionStates,
    post,
    postStates,
    media,
    mediaStates,
    subscriptionStates,
    group,
    groupStates
  };
};

export default connect(state)(MediaViewer);
